// Styles cho các trang Auth (Login, Register, ForgotPassword)

export const authPageStyles = {
  // Container chính
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a2332 0%, #0d1117 100%)',
    padding: 2,
  },

  // Box chứa form và phần chào mừng
  mainBox: {
    backgroundColor: 'rgba(30, 41, 59, 0.95)',
    borderRadius: 4,
    overflow: 'hidden',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.8)',
    border: '1px solid',
    borderColor: 'rgba(100, 200, 255, 0.15)',
  },

  // Phần form
  formSection: {
    p: { xs: 4, md: 6 },
  },

  // Header section
  headerSection: {
    mb: 4,
  },

  // Logo/Title
  logoText: {
    fontWeight: 700,
    mb: 1,
    color: '#00D9FF',
  },

  // Page title
  pageTitle: {
    fontWeight: 600,
    color: 'white',
    mb: 0.5,
  },

  // Subtitle
  subtitle: {
    color: 'rgba(255, 255, 255, 0.5)',
  },

  // Alert
  alert: {
    mb: 3,
  },
};

// Styles cho TextField
export const authInputStyles = {
  mb: 2.5,
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(15, 23, 42, 0.6)',
    '& fieldset': {
      borderColor: 'rgba(100, 116, 139, 0.3)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(0, 217, 255, 0.5)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#00D9FF',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.5)',
  },
  '& .MuiOutlinedInput-input': {
    color: 'white',
  },
};

// Styles cho nút submit
export const authButtonStyles = {
  py: 1.5,
  background: 'linear-gradient(90deg, #00D9FF 0%, #7C3AED 100%)',
  '&:hover': {
    background: 'linear-gradient(90deg, #00B8D4 0%, #6B21A8 100%)',
  },
  '&:disabled': {
    background: 'rgba(100, 116, 139, 0.3)',
  },
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  borderRadius: 2,
};

// Styles cho checkbox
export const authCheckboxStyles = {
  color: 'rgba(255, 255, 255, 0.3)',
  '&.Mui-checked': { 
    color: '#00D9FF' 
  },
};

// Styles cho icon button (show/hide password)
export const authIconButtonStyles = {
  color: 'rgba(255, 255, 255, 0.5)',
};

// Styles cho options section (checkbox + forgot password)
export const authOptionsStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 3,
};

// Styles cho link text
export const authLinkStyles = {
  color: '#00D9FF',
  textDecoration: 'none',
  fontSize: '0.875rem',
};

export const authLinkTextStyles = {
  color: 'rgba(255, 255, 255, 0.5)',
};

// Styles cho phần chào mừng bên phải
export const welcomeSectionStyles = {
  background: 'linear-gradient(90deg, #00D9FF 0%, #7C3AED 100%)',
  p: 5,
  position: 'relative',
  overflow: 'hidden',
};

export const welcomeContentStyles = {
  position: 'relative',
  zIndex: 1,
};

export const welcomeTitleStyles = {
  fontWeight: 700,
  color: 'white',
  mb: 2,
  lineHeight: 1.2,
};

export const welcomeDescriptionStyles = {
  color: 'rgba(255, 255, 255, 0.95)',
  lineHeight: 1.6,
  fontWeight: 400,
};

// Decorative circles
export const decorativeCircle1Styles = {
  position: 'absolute',
  top: -50,
  right: -50,
  width: 200,
  height: 200,
  borderRadius: '50%',
  background: 'rgba(255, 255, 255, 0.1)',
  filter: 'blur(50px)',
};

export const decorativeCircle2Styles = {
  position: 'absolute',
  bottom: -30,
  left: -30,
  width: 150,
  height: 150,
  borderRadius: '50%',
  background: 'rgba(255, 255, 255, 0.1)',
  filter: 'blur(40px)',
};

// Grid styles cho layout 2 cột
export const authGridContainerStyles = {
  backgroundColor: 'rgba(30, 41, 59, 0.95)',
  borderRadius: 4,
  overflow: 'hidden',
  boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.8)',
  border: '1px solid',
  borderColor: 'rgba(100, 200, 255, 0.15)',
};

export const welcomeGridItemStyles = {
  background: 'linear-gradient(135deg, #7C3AED 0%, #00D9FF 100%)',
  display: { xs: 'none', md: 'flex' },
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
};

// Styles cho Stepper (ForgotPassword)
export const stepperStyles = {
  mb: 4,
  '& .MuiStepLabel-label': {
    color: 'text.secondary',
    '&.Mui-active': { color: 'primary.main' },
    '&.Mui-completed': { color: 'success.main' },
  },
};
